import { theme } from '../../../theme';

export const styles = {
  container: { padding: '1rem 2rem 2rem 2rem', maxWidth: '1600px', margin: '0 auto', minHeight: 'calc(100vh - 70px)', boxSizing: 'border-box', backgroundColor: '#F8FAFC', color: '#0F172A', fontFamily: '"Inter", sans-serif' },
  card: { backgroundColor: '#FFFFFF', padding: '25px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)', marginBottom:'20px' },
  input: { width: '100%', padding: '10px', marginBottom: '15px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box', fontSize: '0.9rem', fontFamily: '"Inter", sans-serif', color: '#0F172A' },
  select: { width: '100%', padding: '10px', marginBottom: '15px', border: '1px solid #ddd', borderRadius: '4px', boxSizing: 'border-box', backgroundColor: '#FFFFFF', color: '#0F172A', fontSize: '0.9rem', fontFamily: '"Inter", sans-serif' },
  label: { display: 'block', marginBottom: '5px', fontWeight: 'bold', fontSize: '0.85rem', color: '#0F172A', fontFamily: '"Inter", sans-serif' },
  btnPrimary: { padding: '10px 20px', backgroundColor: '#0D9488', color: '#FFFFFF', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontFamily: '"Inter", sans-serif' },
  btnSecondary: { padding: '8px 12px', backgroundColor: '#0D9488', color: '#FFFFFF', border: 'none', borderRadius: '4px', cursor: 'pointer', fontFamily: '"Inter", sans-serif', fontSize: '0.85rem' },
  btnReversed: { padding: '8px 12px', backgroundColor: '#FFFFFF', color: '#0D9488', border: '1px solid #0D9488', borderRadius: '4px', cursor: 'pointer', fontFamily: '"Inter", sans-serif', fontWeight: 'bold' },
  btnDanger: { padding: '10px 20px', backgroundColor: '#0D9488', color: '#F59E0B', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontFamily: '"Inter", sans-serif' },
  btnDangerOutline: { padding: '8px 12px', backgroundColor: '#FFFFFF', color: '#F59E0B', border: '1px solid #F59E0B', borderRadius: '4px', cursor: 'pointer', fontFamily: '"Inter", sans-serif', fontWeight: 'bold', fontSize: '0.85rem' },
  submitBtn: { width: '100%', padding: '12px', backgroundColor: '#0D9488', color: '#FFFFFF', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '1rem', fontFamily: '"Inter", sans-serif' },
  smBtn: { border:'none', color:'white', padding: '6px 12px', borderRadius:'4px', cursor:'pointer', fontSize:'0.8rem', display:'flex', justifyContent:'center', alignItems:'center', fontFamily: '"Inter", sans-serif' },
  // General small actions (Preview/Regenerate/Send) — Action Teal fill, white text.
  smBtnPrimary: { border:'none', backgroundColor: '#0D9488', color:'white', padding: '6px 12px', borderRadius:'4px', cursor:'pointer', fontSize:'0.8rem', display:'flex', justifyContent:'center', alignItems:'center', fontFamily: '"Inter", sans-serif' },
  // "Dangerous" actions (Void) — dark slate text on the UI Accent Amber, the
  // inverse of smBtnPrimary so it reads as distinct/irreversible at a glance.
  smBtnDanger: { border:'none', backgroundColor: '#F59E0B', color:'#1E293B', padding: '6px 12px', borderRadius:'4px', cursor:'pointer', fontSize:'0.8rem', fontWeight:'bold', display:'flex', justifyContent:'center', alignItems:'center', fontFamily: '"Inter", sans-serif' },
  th: { padding: '12px', borderBottom: '2px solid #ddd', backgroundColor: '#163321', color: '#FFFFFF', fontWeight: 'bold', fontFamily: '"Inter", sans-serif', fontSize: '0.9rem', position: 'sticky', top: 0, zIndex: 10 },
  td: { padding: '12px', verticalAlign: 'middle', color: '#0F172A', fontFamily: '"Inter", sans-serif', fontSize: '0.9rem' },
  h1: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: 'bold', color: '#0F172A' },
  h2: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: '600', color: '#0F172A' },
  h3: { fontFamily: '"Plus Jakarta Sans", sans-serif', fontWeight: '600', color: '#0F172A' },
  textMuted: { color: '#475569', fontFamily: '"Inter", sans-serif' },
  instructionBox: { backgroundColor: '#F8FAFC', border: '1px solid #0D9488', borderLeft: '4px solid #0D9488', borderRadius: '4px', padding: '12px 15px', fontSize: '0.85rem', color: '#475569', fontFamily: '"Inter", sans-serif', marginBottom: '20px', lineHeight: 1.5 },
  overlay: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(15, 23, 42, 0.7)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center' },
  modal: { backgroundColor: '#FFFFFF', width: '1000px', maxWidth: '95%', height: '90%', borderRadius: '8px', boxShadow: '0 10px 25px rgba(0,0,0,0.2)' }
};

// Collapsible sidebar navigation (Admin Dashboard shell)
export const sidebarStyles = {
  sidebar: {
    flexShrink: 0,
    backgroundColor: '#FFFFFF',
    borderRight: '1px solid #E2E8F0',
    minHeight: 'calc(100vh - 70px)',
    position: 'sticky',
    top: '70px',
    display: 'flex',
    flexDirection: 'column',
    transition: 'width 0.25s ease',
    overflow: 'hidden',
    boxSizing: 'border-box'
  },
  toggleRow: { display: 'flex', justifyContent: 'flex-end', padding: '12px' },
  toggleBtn: {
    width: '32px',
    height: '32px',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #E2E8F0',
    borderRadius: '4px',
    backgroundColor: '#F8FAFC',
    color: theme.colors.primary,
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: 'bold',
    transition: 'background-color 0.2s'
  },
  nav: { display: 'flex', flexDirection: 'column', gap: '4px', padding: '4px 10px 16px 10px' },
  sectionLabel: {
    fontSize: '0.7rem',
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    color: '#94A3B8',
    fontWeight: 'bold',
    fontFamily: '"Inter", sans-serif',
    padding: '14px 12px 6px 12px',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  divider: { borderTop: '1px solid #E2E8F0', margin: '10px 12px' },
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    width: '100%',
    padding: '10px 12px',
    border: 'none',
    borderRadius: '6px',
    backgroundColor: 'transparent',
    color: '#475569',
    fontFamily: '"Inter", sans-serif',
    fontSize: '0.9rem',
    fontWeight: 'bold',
    cursor: 'pointer',
    textAlign: 'left',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s, color 0.2s'
  },
  linkActive: { backgroundColor: theme.colors.primary, color: '#FFFFFF' },
  linkHover: { backgroundColor: '#F1F5F9' },
  linkDisabled: { color: '#CBD5E1', cursor: 'not-allowed' },
  linkIcon: { width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  linkTextCol: { display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 },
  linkLabel: { overflow: 'hidden', textOverflow: 'ellipsis' },
  linkHint: { fontSize: '0.7rem', fontWeight: 'normal', color: '#94A3B8', overflow: 'hidden', textOverflow: 'ellipsis' },
  lockIcon: { marginLeft: 'auto', width: '14px', height: '14px', display: 'flex', alignItems: 'center', flexShrink: 0 },
  superLink: { color: '#C0392B' },
  superLinkActive: { backgroundColor: 'rgba(231, 76, 60, 0.85)', color: '#FFFFFF' },
  superLinkHover: { backgroundColor: 'rgba(231, 76, 60, 0.12)' },
  main: { flex: 1, minWidth: 0 }
};
